import { render, staticRenderFns } from "./settingUserJurisdiction.vue?vue&type=template&id=e6f8a33e"
import script from "./settingUserJurisdiction.vue?vue&type=script&lang=js"
export * from "./settingUserJurisdiction.vue?vue&type=script&lang=js"
import style0 from "./settingUserJurisdiction.vue?vue&type=style&index=0&id=e6f8a33e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports